import { useMemo } from 'react';

import { Emoji } from '@/components/Emoji';

import { countryFlag, countryName, countryOptions } from '@shared/countries';

/**
 * Desplegable de países y bandera para mostrarlos.
 *
 * Se guarda el código ISO («VE»), no la bandera: el emoji se compone a
 * partir del código y el nombre lo traduce el propio navegador, así que la
 * lista no hay que mantenerla a mano.
 */
export function CountrySelect({
  id,
  value,
  onChange,
  className = '',
}: {
  id?: string;
  value: string;
  onChange: (code: string) => void;
  className?: string;
}) {
  // La lista se ordena una vez: son 249 nombres que hay que comparar.
  const options = useMemo(() => countryOptions(), []);

  return (
    <select
      id={id}
      className={`input ${className}`}
      value={value}
      onChange={(event) => onChange(event.target.value)}
    >
      <option value="">Prefiero no decirlo</option>
      {options.map((option) => (
        <option key={option.code} value={option.code}>
          {option.flag} {option.name}
        </option>
      ))}
    </select>
  );
}

/**
 * Bandera del país, con su nombre a la vista de quien use lector de pantalla.
 * Se dibuja con Twemoji: Windows no trae banderas y mostraría solo las letras.
 */
export function CountryFlag({ code, className = '' }: { code: string; className?: string }) {
  const name = countryName(code);
  return (
    <span className={className} title={name} aria-label={name} role="img">
      <Emoji emoji={countryFlag(code)} className="h-[1.15em] w-[1.15em] align-[-0.2em]" />
    </span>
  );
}
